import { axiosInstance as request } from '@/api/rest.service'

export const getMilestoneSettings = slug => request.get(`/progress-bar/settings/${slug}`)
export const updateMilestoneSettings = (slug, payload) => request.put(`/progress-bar/settings/${slug}`, payload)
